import {Component, isDevMode, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {CreateEventComponent} from "./create-event/create-event.component";
import {AngularFirestore, DocumentChangeAction} from "@angular/fire/compat/firestore";
import {Observable, Subject, Subscription} from "rxjs";
import {takeUntil} from "rxjs/operators";
import firebase from "firebase/compat";
import Timestamp = firebase.firestore.Timestamp;
import {MatButtonToggleChange} from "@angular/material/button-toggle";
import {Events} from "../../interfaces/FullChild";
import {Router} from "@angular/router";
import {Centre} from "../../interfaces/Centres";
import {environment} from "../../../environments/environment";
import {UserRole} from "../rename/add-user-role/add-user-role.component";
import {PermissionType} from "../employee/PermissionType.enum";
import {MatCalendarCellCssClasses} from "@angular/material/datepicker";
import {EventListDialogComponent} from "./event-list-dialog/event-list-dialog.component";
import { CalendarOptions, EventClickArg, EventInput } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';

export interface ChildObject {
    child_code: string,
    child_name: string
}

export interface CentreObject {
    id: string,
    centreName: string
}

export interface EventModel {
    eventName: string;
    key: string;
    description: string;
    eventDate: Timestamp;
    eventType: string;
    eventSort: 'all' | 'child' | 'centre'
    eventTime: Timestamp;
    name: string;
    email: string;
    eventFor: string;
    code: CentreObject[]
    number: string
    eventLocations: []
    events: Events[]
    volunteer: any[]
    status:string;
}


@Component({
    selector: 'app-events',
    templateUrl: './events.component.html',
    styleUrls: ['./events.component.scss']
})
export class EventsComponent implements OnInit, OnDestroy {
    private _destroyed$ = new Subject<void>();
    events$: Observable<EventModel[]>
    env = isDevMode() ? environment.testMode : environment.productionMode
    admissions:UserRole[] = (localStorage.getItem('permissions') != null) ?  JSON.parse(localStorage.getItem('permissions')!) as UserRole[]: [
        {
            functionName: "Child Admission",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Child Prescreening",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Counselling",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Education",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Meal Mate",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Unit Sponsorship",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "General Donation",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "CMS",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Child Report",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Counseling Report",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Education Report",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Donation Report",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Weekly Report",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Centres",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Employees",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Hospital",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Unit",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Types",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Donor",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Event",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Audit Logs",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Dashboard",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        }
    ];

    Events = this.admissions.filter((x) => x.functionName == 'Event')
  // component.ts
   colorClasses: string[] = ['orangeColor', 'greenColor', 'blueColor', 'redColor'];

  // mRef:Observable<EventModel[]>
  @ViewChild('statusModal') statusModal!: TemplateRef<any>;
  dialogRef: MatDialogRef<any> | null = null;

  selectedEvent: any;
  selectedStatus: string = '';
  selectedIndex: number = 0;
    viewType: 'calendar' | 'cards' = 'cards';
    calendarEvents: any[] = [];
    selectedDate: Date = new Date();

    calendarOptions: CalendarOptions = {
        plugins: [dayGridPlugin, interactionPlugin, listPlugin],
        initialView: 'dayGridMonth',
        headerToolbar: {
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,dayGridWeek,listWeek'
        },
        events: [],
        eventClick: this.handleEventClick.bind(this),
        dateClick: this.handleDateClick.bind(this),
        selectable: true,
        eventTimeFormat: {
            hour: '2-digit',
            minute: '2-digit',
            meridiem: 'short'
        },
        displayEventEnd: true,
        eventClassNames: function(arg) {
            return [`event-${arg.event.extendedProps['status']?.toLowerCase() || 'pending'}`];
        }
    };

    constructor(
        private matDialog: MatDialog,
        private mFirestore: AngularFirestore,
        public dialog: MatDialog,
        private router: Router,
    ) {
        this.events$ = mFirestore.collection<EventModel>(this.env.events)
            .valueChanges({ idField: 'key' });

        // Subscribe to events and format them for calendar
        this.events$.pipe(takeUntil(this._destroyed$)).subscribe(events => {
            const calendarEvents = events.map(event => ({
                id: event.key,
                title: event.eventName,
                start: this.getFormattedDate(event.eventDate, event.eventTime),
                end: this.getFormattedEndDate(event.eventDate, event.eventTime),
                extendedProps: {
                    status: event.status || 'Pending',
                    eventFor: event.eventFor,
                    name: event.name,
                    email: event.email,
                    number: event.number,
                    volunteer: event.volunteer,
                    description: event.description
                },
                backgroundColor: this.getEventColor(event.status).primary,
                borderColor: this.getEventColor(event.status).primary,
                textColor: '#FFF'
            }));

            // Update calendar events
            this.calendarOptions.events = calendarEvents;
        });
    }

    ngOnInit(): void {

    }

updateStatus(): void {
  if (this.selectedEvent) {
    const updatedStatus = this.selectedStatus;
    this.mFirestore
      .collection(this.env.events)
      .doc(this.eventId)
      .update({status: updatedStatus})
      .then(() => {
        this.selectedEvent.status = updatedStatus; // Update UI immediately
        this.dialogRef?.close();
      })
      .catch(error => {
        console.error('Error updating status:', error);
        alert('Failed to update status. Please try again.');
      });
  }
}
  eventId:any;
openStatusModal(event: any, index: number): void {
  this.eventId = event.key;
    this.selectedEvent = event;
    this.selectedStatus = event.status || 'Pending';
    this.selectedIndex = index;
    this.dialogRef = this.dialog.open(this.statusModal);
  }

  handleEventClick(clickInfo: EventClickArg) {
        const event = clickInfo.event;
        this.eventId = event.id;
        this.selectedEvent = {
            key: event.id,
            eventName: event.title,
            ...event.extendedProps
        };

        // Open the edit dialog
        const dialogRef = this.dialog.open(CreateEventComponent, {
            width: '800px',
            data: {
                mode: 'edit',
                event: this.selectedEvent
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === 'deleted') {
                // Refresh events if the event was deleted
                this.events$ = this.mFirestore.collection<EventModel>(this.env.events)
                    .valueChanges({ idField: 'key' });
            }
        });
    }

    handleDateClick(info: any) {
        const dialogRef = this.dialog.open(CreateEventComponent, {
            width: '800px',
            data: {
                mode: 'add',
                date: info.date
            }
        });
    }

    openCreateCenterDialog() {
        const dialogRef = this.dialog.open(CreateEventComponent, {
            width: '800px',
            data: {
                mode: 'add'
            }
        });
    }

    selectionChange($event: MatButtonToggleChange) {
        console.log($event.value)
        switch ($event.value) {
            case 'all' : {
                this.events$ = this.mFirestore.collection<EventModel>(this.env.events).valueChanges({idField: 'key'})
                break;
            }
            case 'Child' : {
                console.log('Child selected')
                this.events$ = this.mFirestore.collection<EventModel>(this.env.events, ref => ref.where('eventFor', '==', `${$event.value}`)).valueChanges({idField: 'key'})
                break;
            }
            case 'Centre': {
                console.log('Centre selected')
                this.events$ = this.mFirestore.collection<EventModel>(this.env.events, ref => ref.where('eventFor', '==', `${$event.value}`)).valueChanges()
                break;
            }
            default: {
                this.events$ = this.mFirestore.collection<EventModel>(this.env.events).valueChanges()
                break;
            }
        }
    }

    // ViewEvent(key: any) {
    //   console.log('EVENT KEY',key)
    // this.router.navigate(['Events',{id:key}])
    // }


    getCenterName(l: string): string {
        console.log('getCEntre', l)
        let name = ''
        this.mFirestore.firestore.doc(`${this.env.centres}/${l}`).get().then(res => {
            let d: Centre;
            d = res as unknown as Centre;
            name = d?.centreName!
        })
        return name
    }

  protected readonly PermissionType = PermissionType;

  toggleView() {
        this.viewType = this.viewType === 'cards' ? 'calendar' : 'cards';
    }

    dateSelected(date: Date | null) {
        if (!date) return;

        this.selectedDate = date;
        // Filter events for the selected date
        const selectedEvents = this.calendarEvents.filter(event => {
            const eventDate = event.start;
            return eventDate.getDate() === date.getDate() &&
                   eventDate.getMonth() === date.getMonth() &&
                   eventDate.getFullYear() === date.getFullYear();
        });

        if (selectedEvents.length > 0) {
            const dialogRef = this.dialog.open(EventListDialogComponent, {
                width: '500px',
                data: { events: selectedEvents, date: date }
            });
        }
    }

    dateClass = (date: Date): MatCalendarCellCssClasses => {
        const events = this.calendarEvents.filter(event => {
            const eventDate = event.start;
            return eventDate.getDate() === date.getDate() &&
                   eventDate.getMonth() === date.getMonth() &&
                   eventDate.getFullYear() === date.getFullYear();
        });

        if (events.length === 0) return '';

        // Check the status of events on this date
        const hasComplete = events.some(e => e.status === 'Complete');
        const hasCancelled = events.some(e => e.status === 'Cancel');

        if (hasComplete) return 'event-complete';
        if (hasCancelled) return 'event-cancelled';
        return 'has-events';
    }

    private getEventColor(status: string | undefined): any {
        switch (status) {
            case 'Complete':
                return { primary: '#4CAF50', secondary: '#C8E6C9' };
            case 'Cancel':
                return { primary: '#F44336', secondary: '#FFCDD2' };
            default:
                return { primary: '#2196F3', secondary: '#BBDEFB' };
        }
    }

    // Helper method to format date and time for calendar
    private getFormattedDate(date: Timestamp, time: Timestamp): Date {
        const eventDate = date.toDate();
        const eventTime = time.toDate();

        return new Date(
            eventDate.getFullYear(),
            eventDate.getMonth(),
            eventDate.getDate(),
            eventTime.getHours(),
            eventTime.getMinutes()
        );
    }

    private getFormattedEndDate(date: Timestamp, time: Timestamp): Date {
        const startDate = this.getFormattedDate(date, time);
        // Add 2 hours as default event duration
        return new Date(startDate.getTime() + (2 * 60 * 60 * 1000));
    }

    ngOnDestroy(): void {
        this._destroyed$.next();
        this._destroyed$.complete();
    }
}

